import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Redirect} from "react-router-dom";
import {CButton, CCard, CCardBody} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {States} from "../store/ducks/rootReducer";
import {StatusTypes} from "../store/ducks/login/types";
import {loggingOff} from "../store/ducks/login/actions";
import {clearToken} from "../services/tokenVerify";
import {loadAuthDataFromToken} from "../services/authStoreLoad";
import {modulosVisiveis, statusPagina} from "../services/acesso";

// Guarda das paginas (#484909). Esconder o menu nao basta: link direto e
// favorito continuam abrindo a tela. A API confere de novo de qualquer forma.

const Aviso = (props: {icone: string, titulo: string, texto: string, sair?: boolean}) => {
    const dispatch = useDispatch();
    const sair = () => {
        dispatch(loggingOff());
        clearToken();
    };
    return (
        <CCard className="mt-4 mx-auto" style={{maxWidth: 520}}>
            <CCardBody className="text-center py-5">
                <CIcon name={props.icone} height={40} className="mb-3 text-muted"/>
                <h4>{props.titulo}</h4>
                <p className="text-muted mb-0">{props.texto}</p>
                {props.sair && (
                    <CButton color="primary" className="mt-4" onClick={sair}>Sair</CButton>
                )}
            </CCardBody>
        </CCard>
    );
};

export const AcessoNegado = () => (
    <Aviso icone="cil-lock-locked" titulo="Acesso negado"
           texto="Seu perfil não permite abrir esta página. Se precisar dela, fale com o responsável pelos acessos."/>
);

export const PaginaNaoEncontrada = () => (
    <Aviso icone="cil-warning" titulo="Página não encontrada" texto="O endereço não corresponde a nenhuma página do Admin."/>
);

export const SemAcesso = () => (
    <Aviso icone="cil-ban" titulo="Sem acesso"
           texto="Seu usuário não possui acesso aos módulos. Entre em contato com o responsável." sair/>
);

const Carregando = () => <div className="p-4 text-muted">Carregando...</div>;

/** Abre a pagina so se o acesso do usuario permitir. `pagina` e o template do registro. */
export const GuardaPagina = (props: {pagina: string, children: React.ReactNode}) => {
    const acesso = useSelector((state: States) => state.login.data?.acesso);
    if (!acesso) {
        return <Carregando/>;
    }
    if (statusPagina(acesso, props.pagina) === 'negada') {
        return <AcessoNegado/>;
    }
    return <>{props.children}</>;
};

/**
 * Raiz do Admin: em branco, so com o menu do modulo. E onde o login e a troca
 * de modulo caem; a tela o usuario escolhe na sidebar. Sem modulo liberado,
 * avisa.
 */
export const PaginaInicial = () => {
    const acesso = useSelector((state: States) => state.login.data?.acesso);
    if (!acesso) {
        return <Carregando/>;
    }
    return modulosVisiveis(acesso).length ? null : <SemAcesso/>;
};

/**
 * Para as paginas fora do layout do Admin (ex.: impressao da retrospectiva,
 * que abre em outra aba): carrega a sessao, que o Home carregaria, e guarda.
 */
export const GuardaForaDoLayout = (props: {pagina: string, children: React.ReactNode}) => {
    const dispatch = useDispatch();
    const status = useSelector((state: States) => state.login.status);
    const acesso = useSelector((state: States) => state.login.data?.acesso);

    useEffect(() => {
        if (!acesso) {
            dispatch(loadAuthDataFromToken() as any);
        }
        // So na abertura: depois o estado ja tem o acesso.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (status === StatusTypes.UNLOGGED) {
        return <Redirect to="/login"/>;
    }
    if (!acesso) {
        return <Carregando/>;
    }
    return <GuardaPagina pagina={props.pagina}>{props.children}</GuardaPagina>;
};
